import {DialogCallbacks} from 'types/common';
import api from 'api';
import types from '../types';
import {usePostApiDispatch} from 'common/hooks/usePostApiDispatch';

export const useServerLogins = (logins: boolean, cbs?: DialogCallbacks) =>
   usePostApiDispatch(api.serverLogins, types.POST_SERVER_LOGINS, {
      data: {
         logins,
      },
      ...cbs,
   });
